import { colors } from '@material-ui/core';

export default {
  root: {
    cursor: 'pointer',
    textTransform: 'none',
    width: 'max-content',
  },
};
